<div *ngIf="stepsNumber > 1" class="progress-steps">

  <div class="step-container">
    <div [ngClass]="currentStep > 0 ? barColor : 'bg-gray-006'" class="step">
      <span></span>
    </div>
  </div>

  <div *ngFor="let i of steps;" class="step-container">
    <span *ngIf="currentStep==i && currentStep+remain > i" [ngClass]="barColor" class="line"
      [style]="'width: calc(100% * ' + remain + ');'"></span>
    <span *ngIf="currentStep==i && currentStep+remain > i" [ngClass]="currentStep > i ? barColor : 'bg-gray-006'" class="line"
        [style]="'width: calc(100% - (100% * ' + remain + '));'"></span>
    <span *ngIf="currentStep!=i || currentStep+remain==i" [ngClass]="currentStep > i ? barColor : 'bg-gray-006'" class="line"></span>
    <div [ngClass]="currentStep > i ? barColor : 'bg-gray-006'" class="step">
      <span></span>
    </div>
  </div>

</div>